import {message} from '@sail/intl';
import type {ConnectElementConfig} from '../ConnectElementList';
import {ComponentOverrideFlag} from '../../../utils/flags/flags';

const messages = {
  errorText: message({
    id: 'connectEmbed.balanceReport.errorBoundary.text',
    defaultMessage: 'Your balance report cannot be loaded.',
    description: 'Message shown when an unhandled report error is caught',
  }),
};

export const BalanceReportConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "balanceReport" */ '../../../components/Reporting/BalanceReport/BalanceReport'
    ),
  messageOverrides: messages,
  syntheticTestInfo: {
    testUrl: 'https://amp.corp.stripe.com/synthetics/us-west-2/balance-report',
  },
  docSitePath: '/connect/supported-embedded-components/balance-report',
  releaseState: 'ga',
  enabledKey: 'balance_report',
  enabledOverrideFlag: ComponentOverrideFlag.balance_report,
  sentryTeam: 'accounts_ui',
  teamOwner: 'connected-account-experiences-eng',
  description: 'Displays the balance report for a connected account.',
  friendlyName: 'Balance report',
};
